import React, { forwardRef, useCallback } from 'react';

import { cn } from '../../lib/utils';

import { useListNavigation } from '../../hooks/useListNavigation';

export const SuggestionList = forwardRef(({ items, onSelect, renderItem, itemClassName, query }, ref) => {
  const getItemKey = useCallback((item) => `${item.entity_type || 'item'}:${item.id}`, []);

  const { selectedIndex, createMouseEnterHandler, createClickHandler, onMouseLeave } = useListNavigation({
    items,
    onSelect,
    ref,
    wrap: true,
    additionalSelectKeys: ['Tab'],
    initialIndex: 0,
    getItemKey,
    missingSelectionFallbackIndex: 0,
    selectionResetKey: query,
  });

  return (
    <div className="flex max-w-80 min-w-64 flex-col items-start! gap-0.5 overflow-auto text-sm" onMouseLeave={onMouseLeave}>
      {items.length ? (
        items.map((item, index) => (
          <button
            type="button"
            key={getItemKey(item)}
            onClick={createClickHandler(index)}
            onMouseMove={createMouseEnterHandler(index)}
            className={cn(
              // Row treatment mirrors MenuButton (the right-click menu spec): rounded-lg tiles
              // concentric with GlassWrapper's rounded-xl shell, same selection wash.
              'flex h-10 w-full cursor-pointer items-center overflow-hidden rounded-lg px-2.5 text-gray-800 duration-100 ease-out motion-safe:transition-colors dark:text-neutral-200',
              index === selectedIndex && 'bg-white dark:bg-neutral-400/40',
              itemClassName,
            )}
          >
            {renderItem(item)}
          </button>
        ))
      ) : (
        <div className="p-1.5 text-gray-500">No result</div>
      )}
    </div>
  );
});

SuggestionList.displayName = 'SuggestionList';
